/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthSilentRouteImport } from './routes/auth/silent'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthenticatedFormTestRouteImport } from './routes/_authenticated/formTest'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedEntityRouteRouteImport } from './routes/_authenticated/$entity/route'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedEntityIndexRouteImport } from './routes/_authenticated/$entity/index'
import { Route as AuthenticatedSettingsSectionRouteImport } from './routes/_authenticated/settings/$section'
import { Route as AuthenticatedEntityLayoutRouteImport } from './routes/_authenticated/$entity/layout'
import { Route as AuthenticatedEntityCreateRouteImport } from './routes/_authenticated/$entity/create'
import { Route as AuthenticatedEntitySpecialRouteRouteImport } from './routes/_authenticated/$entity/special/route'
import { Route as AuthenticatedEntityEntityIdRouteRouteImport } from './routes/_authenticated/$entity/$entityId/route'
import { Route as AuthenticatedEntityEntityIdTemplatesRouteImport } from './routes/_authenticated/$entity/$entityId/templates'
import { Route as AuthenticatedEntityEntityIdDetailsRouteImport } from './routes/_authenticated/$entity/$entityId/details'
import { Route as AuthenticatedEntityEntityIdTabRouteImport } from './routes/_authenticated/$entity/$entityId/$tab'
import { Route as AuthenticatedEntityEntityIdSettingsRouteRouteImport } from './routes/_authenticated/$entity/$entityId/settings/route'
import { Route as AuthenticatedEntityEntityIdSettingsSectionRouteImport } from './routes/_authenticated/$entity/$entityId/settings/$section'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthSilentRoute = AuthSilentRouteImport.update({
  id: '/silent',
  path: '/silent',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => AuthRoute,
} as any)
const AuthenticatedFormTestRoute = AuthenticatedFormTestRouteImport.update({
  id: '/formTest',
  path: '/formTest',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEntityRouteRoute =
  AuthenticatedEntityRouteRouteImport.update({
    id: '/$entity',
    path: '/$entity',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedEntityIndexRoute =
  AuthenticatedEntityIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedEntityRouteRoute,
  } as any)
const AuthenticatedSettingsSectionRoute =
  AuthenticatedSettingsSectionRouteImport.update({
    id: '/$section',
    path: '/$section',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedEntityLayoutRoute =
  AuthenticatedEntityLayoutRouteImport.update({
    id: '/layout',
    path: '/layout',
    getParentRoute: () => AuthenticatedEntityRouteRoute,
  } as any)
const AuthenticatedEntityCreateRoute =
  AuthenticatedEntityCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedEntityRouteRoute,
  } as any)
const AuthenticatedEntitySpecialRouteRoute =
  AuthenticatedEntitySpecialRouteRouteImport.update({
    id: '/special',
    path: '/special',
    getParentRoute: () => AuthenticatedEntityRouteRoute,
  } as any)
const AuthenticatedEntityEntityIdRouteRoute =
  AuthenticatedEntityEntityIdRouteRouteImport.update({
    id: '/$entityId',
    path: '/$entityId',
    getParentRoute: () => AuthenticatedEntityRouteRoute,
  } as any)
const AuthenticatedEntityEntityIdTemplatesRoute =
  AuthenticatedEntityEntityIdTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AuthenticatedEntityEntityIdRouteRoute,
  } as any)
const AuthenticatedEntityEntityIdDetailsRoute =
  AuthenticatedEntityEntityIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AuthenticatedEntityEntityIdRouteRoute,
  } as any)
const AuthenticatedEntityEntityIdTabRoute =
  AuthenticatedEntityEntityIdTabRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () => AuthenticatedEntityEntityIdRouteRoute,
  } as any)
const AuthenticatedEntityEntityIdSettingsRouteRoute =
  AuthenticatedEntityEntityIdSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedEntityEntityIdRouteRoute,
  } as any)
const AuthenticatedEntityEntityIdSettingsSectionRoute =
  AuthenticatedEntityEntityIdSettingsSectionRouteImport.update({
    id: '/$section',
    path: '/$section',
    getParentRoute: () => AuthenticatedEntityEntityIdSettingsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/$entity': typeof AuthenticatedEntityRouteRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/formTest': typeof AuthenticatedFormTestRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/silent': typeof AuthSilentRoute
  '/$entity/$entityId': typeof AuthenticatedEntityEntityIdRouteRouteWithChildren
  '/$entity/special': typeof AuthenticatedEntitySpecialRouteRoute
  '/$entity/create': typeof AuthenticatedEntityCreateRoute
  '/$entity/layout': typeof AuthenticatedEntityLayoutRoute
  '/settings/$section': typeof AuthenticatedSettingsSectionRoute
  '/$entity/': typeof AuthenticatedEntityIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/$entity/$entityId/settings': typeof AuthenticatedEntityEntityIdSettingsRouteRouteWithChildren
  '/$entity/$entityId/$tab': typeof AuthenticatedEntityEntityIdTabRoute
  '/$entity/$entityId/details': typeof AuthenticatedEntityEntityIdDetailsRoute
  '/$entity/$entityId/templates': typeof AuthenticatedEntityEntityIdTemplatesRoute
  '/$entity/$entityId/settings/$section': typeof AuthenticatedEntityEntityIdSettingsSectionRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/formTest': typeof AuthenticatedFormTestRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/silent': typeof AuthSilentRoute
  '/': typeof AuthenticatedIndexRoute
  '/$entity/$entityId': typeof AuthenticatedEntityEntityIdRouteRouteWithChildren
  '/$entity/special': typeof AuthenticatedEntitySpecialRouteRoute
  '/$entity/create': typeof AuthenticatedEntityCreateRoute
  '/$entity/layout': typeof AuthenticatedEntityLayoutRoute
  '/settings/$section': typeof AuthenticatedSettingsSectionRoute
  '/$entity': typeof AuthenticatedEntityIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/$entity/$entityId/settings': typeof AuthenticatedEntityEntityIdSettingsRouteRouteWithChildren
  '/$entity/$entityId/$tab': typeof AuthenticatedEntityEntityIdTabRoute
  '/$entity/$entityId/details': typeof AuthenticatedEntityEntityIdDetailsRoute
  '/$entity/$entityId/templates': typeof AuthenticatedEntityEntityIdTemplatesRoute
  '/$entity/$entityId/settings/$section': typeof AuthenticatedEntityEntityIdSettingsSectionRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/$entity': typeof AuthenticatedEntityRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/_authenticated/formTest': typeof AuthenticatedFormTestRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/silent': typeof AuthSilentRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/$entity/$entityId': typeof AuthenticatedEntityEntityIdRouteRouteWithChildren
  '/_authenticated/$entity/special': typeof AuthenticatedEntitySpecialRouteRoute
  '/_authenticated/$entity/create': typeof AuthenticatedEntityCreateRoute
  '/_authenticated/$entity/layout': typeof AuthenticatedEntityLayoutRoute
  '/_authenticated/settings/$section': typeof AuthenticatedSettingsSectionRoute
  '/_authenticated/$entity/': typeof AuthenticatedEntityIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/$entity/$entityId/settings': typeof AuthenticatedEntityEntityIdSettingsRouteRouteWithChildren
  '/_authenticated/$entity/$entityId/$tab': typeof AuthenticatedEntityEntityIdTabRoute
  '/_authenticated/$entity/$entityId/details': typeof AuthenticatedEntityEntityIdDetailsRoute
  '/_authenticated/$entity/$entityId/templates': typeof AuthenticatedEntityEntityIdTemplatesRoute
  '/_authenticated/$entity/$entityId/settings/$section': typeof AuthenticatedEntityEntityIdSettingsSectionRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/login'
    | '/$entity'
    | '/settings'
    | '/formTest'
    | '/auth/callback'
    | '/auth/silent'
    | '/$entity/$entityId'
    | '/$entity/special'
    | '/$entity/create'
    | '/$entity/layout'
    | '/settings/$section'
    | '/$entity/'
    | '/settings/'
    | '/$entity/$entityId/settings'
    | '/$entity/$entityId/$tab'
    | '/$entity/$entityId/details'
    | '/$entity/$entityId/templates'
    | '/$entity/$entityId/settings/$section'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/login'
    | '/formTest'
    | '/auth/callback'
    | '/auth/silent'
    | '/'
    | '/$entity/$entityId'
    | '/$entity/special'
    | '/$entity/create'
    | '/$entity/layout'
    | '/settings/$section'
    | '/$entity'
    | '/settings'
    | '/$entity/$entityId/settings'
    | '/$entity/$entityId/$tab'
    | '/$entity/$entityId/details'
    | '/$entity/$entityId/templates'
    | '/$entity/$entityId/settings/$section'
  id:
    | '__root__'
    | '/_authenticated'
    | '/auth'
    | '/login'
    | '/_authenticated/$entity'
    | '/_authenticated/settings'
    | '/_authenticated/formTest'
    | '/auth/callback'
    | '/auth/silent'
    | '/_authenticated/'
    | '/_authenticated/$entity/$entityId'
    | '/_authenticated/$entity/special'
    | '/_authenticated/$entity/create'
    | '/_authenticated/$entity/layout'
    | '/_authenticated/settings/$section'
    | '/_authenticated/$entity/'
    | '/_authenticated/settings/'
    | '/_authenticated/$entity/$entityId/settings'
    | '/_authenticated/$entity/$entityId/$tab'
    | '/_authenticated/$entity/$entityId/details'
    | '/_authenticated/$entity/$entityId/templates'
    | '/_authenticated/$entity/$entityId/settings/$section'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/auth/silent': {
      id: '/auth/silent'
      path: '/silent'
      fullPath: '/auth/silent'
      preLoaderRoute: typeof AuthSilentRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authenticated/formTest': {
      id: '/_authenticated/formTest'
      path: '/formTest'
      fullPath: '/formTest'
      preLoaderRoute: typeof AuthenticatedFormTestRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/$entity': {
      id: '/_authenticated/$entity'
      path: '/$entity'
      fullPath: '/$entity'
      preLoaderRoute: typeof AuthenticatedEntityRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/$entity/': {
      id: '/_authenticated/$entity/'
      path: '/'
      fullPath: '/$entity/'
      preLoaderRoute: typeof AuthenticatedEntityIndexRouteImport
      parentRoute: typeof AuthenticatedEntityRouteRoute
    }
    '/_authenticated/settings/$section': {
      id: '/_authenticated/settings/$section'
      path: '/$section'
      fullPath: '/settings/$section'
      preLoaderRoute: typeof AuthenticatedSettingsSectionRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/$entity/layout': {
      id: '/_authenticated/$entity/layout'
      path: '/layout'
      fullPath: '/$entity/layout'
      preLoaderRoute: typeof AuthenticatedEntityLayoutRouteImport
      parentRoute: typeof AuthenticatedEntityRouteRoute
    }
    '/_authenticated/$entity/create': {
      id: '/_authenticated/$entity/create'
      path: '/create'
      fullPath: '/$entity/create'
      preLoaderRoute: typeof AuthenticatedEntityCreateRouteImport
      parentRoute: typeof AuthenticatedEntityRouteRoute
    }
    '/_authenticated/$entity/special': {
      id: '/_authenticated/$entity/special'
      path: '/special'
      fullPath: '/$entity/special'
      preLoaderRoute: typeof AuthenticatedEntitySpecialRouteRouteImport
      parentRoute: typeof AuthenticatedEntityRouteRoute
    }
    '/_authenticated/$entity/$entityId': {
      id: '/_authenticated/$entity/$entityId'
      path: '/$entityId'
      fullPath: '/$entity/$entityId'
      preLoaderRoute: typeof AuthenticatedEntityEntityIdRouteRouteImport
      parentRoute: typeof AuthenticatedEntityRouteRoute
    }
    '/_authenticated/$entity/$entityId/templates': {
      id: '/_authenticated/$entity/$entityId/templates'
      path: '/templates'
      fullPath: '/$entity/$entityId/templates'
      preLoaderRoute: typeof AuthenticatedEntityEntityIdTemplatesRouteImport
      parentRoute: typeof AuthenticatedEntityEntityIdRouteRoute
    }
    '/_authenticated/$entity/$entityId/details': {
      id: '/_authenticated/$entity/$entityId/details'
      path: '/details'
      fullPath: '/$entity/$entityId/details'
      preLoaderRoute: typeof AuthenticatedEntityEntityIdDetailsRouteImport
      parentRoute: typeof AuthenticatedEntityEntityIdRouteRoute
    }
    '/_authenticated/$entity/$entityId/$tab': {
      id: '/_authenticated/$entity/$entityId/$tab'
      path: '/$tab'
      fullPath: '/$entity/$entityId/$tab'
      preLoaderRoute: typeof AuthenticatedEntityEntityIdTabRouteImport
      parentRoute: typeof AuthenticatedEntityEntityIdRouteRoute
    }
    '/_authenticated/$entity/$entityId/settings': {
      id: '/_authenticated/$entity/$entityId/settings'
      path: '/settings'
      fullPath: '/$entity/$entityId/settings'
      preLoaderRoute: typeof AuthenticatedEntityEntityIdSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedEntityEntityIdRouteRoute
    }
    '/_authenticated/$entity/$entityId/settings/$section': {
      id: '/_authenticated/$entity/$entityId/settings/$section'
      path: '/$section'
      fullPath: '/$entity/$entityId/settings/$section'
      preLoaderRoute: typeof AuthenticatedEntityEntityIdSettingsSectionRouteImport
      parentRoute: typeof AuthenticatedEntityEntityIdSettingsRouteRoute
    }
  }
}

interface AuthenticatedEntityEntityIdSettingsRouteRouteChildren {
  AuthenticatedEntityEntityIdSettingsSectionRoute: typeof AuthenticatedEntityEntityIdSettingsSectionRoute
}

const AuthenticatedEntityEntityIdSettingsRouteRouteChildren: AuthenticatedEntityEntityIdSettingsRouteRouteChildren =
  {
    AuthenticatedEntityEntityIdSettingsSectionRoute:
      AuthenticatedEntityEntityIdSettingsSectionRoute,
  }

const AuthenticatedEntityEntityIdSettingsRouteRouteWithChildren =
  AuthenticatedEntityEntityIdSettingsRouteRoute._addFileChildren(
    AuthenticatedEntityEntityIdSettingsRouteRouteChildren,
  )

interface AuthenticatedEntityEntityIdRouteRouteChildren {
  AuthenticatedEntityEntityIdSettingsRouteRoute: typeof AuthenticatedEntityEntityIdSettingsRouteRouteWithChildren
  AuthenticatedEntityEntityIdTabRoute: typeof AuthenticatedEntityEntityIdTabRoute
  AuthenticatedEntityEntityIdDetailsRoute: typeof AuthenticatedEntityEntityIdDetailsRoute
  AuthenticatedEntityEntityIdTemplatesRoute: typeof AuthenticatedEntityEntityIdTemplatesRoute
}

const AuthenticatedEntityEntityIdRouteRouteChildren: AuthenticatedEntityEntityIdRouteRouteChildren =
  {
    AuthenticatedEntityEntityIdSettingsRouteRoute:
      AuthenticatedEntityEntityIdSettingsRouteRouteWithChildren,
    AuthenticatedEntityEntityIdTabRoute: AuthenticatedEntityEntityIdTabRoute,
    AuthenticatedEntityEntityIdDetailsRoute:
      AuthenticatedEntityEntityIdDetailsRoute,
    AuthenticatedEntityEntityIdTemplatesRoute:
      AuthenticatedEntityEntityIdTemplatesRoute,
  }

const AuthenticatedEntityEntityIdRouteRouteWithChildren =
  AuthenticatedEntityEntityIdRouteRoute._addFileChildren(
    AuthenticatedEntityEntityIdRouteRouteChildren,
  )

interface AuthenticatedEntityRouteRouteChildren {
  AuthenticatedEntityEntityIdRouteRoute: typeof AuthenticatedEntityEntityIdRouteRouteWithChildren
  AuthenticatedEntitySpecialRouteRoute: typeof AuthenticatedEntitySpecialRouteRoute
  AuthenticatedEntityCreateRoute: typeof AuthenticatedEntityCreateRoute
  AuthenticatedEntityLayoutRoute: typeof AuthenticatedEntityLayoutRoute
  AuthenticatedEntityIndexRoute: typeof AuthenticatedEntityIndexRoute
}

const AuthenticatedEntityRouteRouteChildren: AuthenticatedEntityRouteRouteChildren =
  {
    AuthenticatedEntityEntityIdRouteRoute:
      AuthenticatedEntityEntityIdRouteRouteWithChildren,
    AuthenticatedEntitySpecialRouteRoute: AuthenticatedEntitySpecialRouteRoute,
    AuthenticatedEntityCreateRoute: AuthenticatedEntityCreateRoute,
    AuthenticatedEntityLayoutRoute: AuthenticatedEntityLayoutRoute,
    AuthenticatedEntityIndexRoute: AuthenticatedEntityIndexRoute,
  }

const AuthenticatedEntityRouteRouteWithChildren =
  AuthenticatedEntityRouteRoute._addFileChildren(
    AuthenticatedEntityRouteRouteChildren,
  )

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsSectionRoute: typeof AuthenticatedSettingsSectionRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsSectionRoute: AuthenticatedSettingsSectionRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedEntityRouteRoute: typeof AuthenticatedEntityRouteRouteWithChildren
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedFormTestRoute: typeof AuthenticatedFormTestRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedEntityRouteRoute: AuthenticatedEntityRouteRouteWithChildren,
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedFormTestRoute: AuthenticatedFormTestRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface AuthRouteChildren {
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthSilentRoute: typeof AuthSilentRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCallbackRoute: AuthCallbackRoute,
  AuthSilentRoute: AuthSilentRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
